import { QUERY_COLOR, rubricColor } from "@/tools/rubric-colors";

const QUERY_TITLE = "Поиск";

// Обрамляет слова из query/rubric-highlights в <span class="news-hl">
// с inline text-decoration-color и native-tooltip (title): рубрика или
// «Поиск» подсказывают, почему слово подсвечено. Работает по HTML-строке:
// обходит только текстовые куски, теги и HTML-сущности пропускает как есть.
//
// Аргументы:
//   html — исходная разметка (title / raw_text / plain).
//   options.queryWords — слова из поискового запроса (query_highlights).
//   options.rubrics — [{ name, terms }] по рубрикам, куда попала статья, в том же
//     порядке, что и чипы рубрик. Цвет подсветки берётся по позиции рубрики
//     в этом массиве, поэтому порядок важен. Если одно и то же слово
//     матчится в нескольких рубриках, выигрывает первая в массиве.
export function highlightHtml(html, options = {}) {
    if (!html) return "";
    const { queryWords = [], rubrics = [] } = options;

    const querySet = normalize(queryWords);
    const termInfo = buildTermInfoMap(rubrics);

    if (!querySet.size && !termInfo.size) return String(html);

    return String(html)
        .split(/(<[^>]*>|&[a-zA-Z#0-9]+;)/)
        .map((part) => {
            if (!part) return part;
            const first = part.charCodeAt(0);
            // 60 = '<', 38 = '&' — пропускаем теги и HTML-сущности.
            if (first === 60 || first === 38) return part;
            return part.replace(/([а-яА-ЯёЁa-zA-Z0-9]+)/g, (match) => {
                const lower = match.toLowerCase();
                if (querySet.has(lower)) return wrap(match, QUERY_COLOR, QUERY_TITLE);
                const info = termInfo.get(lower);
                if (info) return wrap(match, info.color, info.title);
                return match;
            });
        })
        .join("");
}

function wrap(text, color, title) {
    const titleAttr = title ? ` title="${escapeAttr(title)}"` : "";
    return `<span class="news-hl" style="text-decoration-color:${color}"${titleAttr}>${text}</span>`;
}

function buildTermInfoMap(rubrics) {
    const map = new Map();
    if (!Array.isArray(rubrics)) return map;
    // Идём с конца, чтобы первая рубрика перекрывала последующие для общих терминов.
    for (let i = rubrics.length - 1; i >= 0; i--) {
        const group = rubrics[i];
        if (!group) continue;
        // Цвет — по позиции в списке, тот же, что и у чипа рубрики.
        const color = rubricColor(i);
        const title = typeof group.name === "string" ? group.name : "";
        const terms = Array.isArray(group.terms) ? group.terms : [];
        for (const t of terms) {
            if (typeof t !== "string") continue;
            const key = t.trim().toLowerCase();
            if (key) map.set(key, { color, title });
        }
    }
    return map;
}

function normalize(words) {
    const set = new Set();
    if (!Array.isArray(words)) return set;
    for (const w of words) {
        if (typeof w !== "string") continue;
        const trimmed = w.trim().toLowerCase();
        if (trimmed) set.add(trimmed);
    }
    return set;
}

function escapeAttr(str) {
    return String(str)
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
}
